import React, { useEffect } from 'react'
import { Accordion } from 'primereact/accordion'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import { connect } from 'react-redux'

import {
  Btn,
  CustomAccordionTab,
  HeaderText,
  ThreeDots,
  UploadMultFileBtn,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useFaltas, { LOAD_MESSAGE } from './FaltasHook'
import {
  urlFotosFalta,
  urlUploadFotoFalta,
} from '../../../../../services/api/routes/picking.routes'
import { isRouteAllowed } from '../../../../../services/permission/menus'
import ModalFotosOcorrencias from '../../ResumoSeparacaoManual/ModalFotosOcorrencias/ModalFotosOcorrencias'
import { getResumoSeparacaoQuantidadeFracionada } from '../quantity-fracionada.helper'
import ModalDesdobramentoFalta from './ModalDesdobramentoFalta/ModalDesdobramentoFalta'
import ModalAjusteOcorrenciaFalta from './ModalAjusteOcorrenciaFalta'

const AJUSTE_OCORRENCIA_PERMISSION = 145

function Faltas({ faltasItems, reasons, selectedPicking, dispatch, onDesdobrado }) {
  const { state, localDispatch } = useFaltas()
  const menuItems = isRouteAllowed(AJUSTE_OCORRENCIA_PERMISSION)
    ? ['Desdobrar Falta', 'Ajuste da Ocorrência']
    : ['Desdobrar Falta']

  const renderQuantidadeCell = (falta, field, type) => {
    const quantidade = getResumoSeparacaoQuantidadeFracionada(falta, field)
    const value = type === 'volume' ? quantidade.volumeText : quantidade.unitsText
    const label = type === 'volume' ? quantidade.volumeLabel : quantidade.unitsLabel
    const defaultLabel = type === 'volume' ? 'Vol.' : 'Frac.'

    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontWeight: 600 }}>{value}</div>
        {label !== defaultLabel ? (
          <div style={{ fontSize: '0.72rem', marginTop: 2 }}>{label}</div>
        ) : null}
      </div>
    )
  }

  const handleMenuClick = (menuItem, falta) => {
    if (menuItem === 'Desdobrar Falta') {
      localDispatch.onDesdobrarFaltaClicked(falta)
    } else if (menuItem === 'Ajuste da Ocorrência') {
      localDispatch.onAjusteOcorrenciaClicked(falta)
    }
  }

  const onAjusteOcorrenciaSaved = () => {
    localDispatch.onAjusteOcorrenciaModalClose()
    onDesdobrado()
  }

  useEffect(() => {
    localDispatch.onInit(selectedPicking, faltasItems)
  }, [faltasItems, selectedPicking])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.ASSOCIANDO:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.associateOcorrencias(faltasItems)
        break
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Ocorrências associadas com sucesso', null))
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  if (state.faltasItems && state.faltasItems.length) {
    return (
      <div className="Faltas">
        <HeaderText>Listagem de Clientes com Falta(s) :</HeaderText>
        <div style={{ marginTop: 10, marginBottom: 25 }}>
          <Btn disabled={state.btnAssociarDisabled} onClick={localDispatch.onBtnClicked}>
            Associar Ocorrência(s)
          </Btn>
        </div>
        <div className="main_container">
          <Accordion activeIndex={state.activeIndex} onTabChange={localDispatch.onTabChange}>
            {state.faltasItems.map(item => {
              const { company_code, nome_fantasia, city, district } = item
              const headerTitle = `${company_code} - ${nome_fantasia} - ${city} - ${district} `
              return (
                <CustomAccordionTab header={headerTitle} key={item.cnpj}>
                  <DataTable value={item.faltas}>
                    <Column field="ciclo_id" header="Ciclo" style={tableCellCentered()} />
                    <Column
                      field="identifier"
                      header="Identificador"
                      style={tableCellCentered(250)}
                    />
                    <Column field="product_code" header="Código" style={tableCellCentered(250)} />
                    <Column field="product_name" header="Produto" />
                    <Column
                      header="Vol."
                      style={tableCellCentered(110)}
                      body={falta =>
                        renderQuantidadeCell(
                          falta,
                          falta.qte_missing_adjusted !== undefined
                            ? 'qte_missing_adjusted'
                            : 'qte_missing',
                          'volume',
                        )
                      }
                    />
                    <Column
                      header="Frac."
                      style={tableCellCentered(110)}
                      body={falta =>
                        renderQuantidadeCell(
                          falta,
                          falta.qte_missing_adjusted !== undefined
                            ? 'qte_missing_adjusted'
                            : 'qte_missing',
                          'units',
                        )
                      }
                    />
                    <Column
                      header="Ocorrência"
                      style={tableCellCentered(320)}
                      body={falta => {
                        return (
                          <Dropdown
                            disabled={state.btnAssociarDisabled}
                            style={{ width: '100%' }}
                            optionLabel="name"
                            value={falta.missing_reason}
                            options={reasons}
                            onChange={({ value }) => localDispatch.onDropdownChange(falta, value)}
                            placeholder="Selecione o Tipo de Ocorrência"
                          />
                        )
                      }}
                    />
                    <Column
                      header="Fotos"
                      body={falta => (
                        <Btn
                          onClick={() => localDispatch.onVerFotosClicked(falta, item)}
                          disabled={!falta.files.length}
                        >
                          Ver Fotos ({falta.files.length})
                        </Btn>
                      )}
                      style={tableCellCentered(120)}
                    />
                    <Column
                      header=""
                      style={tableCellCentered(160)}
                      body={falta => (
                        <div style={{ position: 'relative', top: '-20px' }}>
                          <UploadMultFileBtn
                            label="Anexar Fotos"
                            name="faltas"
                            accept="image/*"
                            url={urlUploadFotoFalta()}
                            onUploadCompleted={file_name =>
                              localDispatch.onUploadCompleted(
                                file_name,
                                falta,
                                item,
                                selectedPicking.id,
                              )
                            }
                          />
                        </div>
                      )}
                    />
                    <Column
                      header="Menu"
                      style={tableCellCentered(60)}
                      body={falta => (
                        <ThreeDots
                          items={menuItems}
                          onClick={menuItem => handleMenuClick(menuItem, falta)}
                        />
                      )}
                    />
                  </DataTable>
                </CustomAccordionTab>
              )
            })}
          </Accordion>
        </div>
        <ModalFotosOcorrencias
          show={state.modal.show}
          onModalClose={localDispatch.onModalClose}
          data={state.modal.data}
          selectedPicking={selectedPicking}
          onDelete={localDispatch.onDeleteFoto}
          urlFoto={urlFotosFalta}
        />
        <ModalDesdobramentoFalta
          show={state.desdobramentoModal.show}
          falta={state.desdobramentoModal.falta}
          reasons={reasons}
          onClose={localDispatch.onDesdobramentoModalClose}
          onSaved={onDesdobrado}
        />
        <ModalAjusteOcorrenciaFalta
          show={state.ajusteOcorrenciaModal.show}
          falta={state.ajusteOcorrenciaModal.falta}
          reasons={reasons}
          onClose={localDispatch.onAjusteOcorrenciaModalClose}
          onSaved={onAjusteOcorrenciaSaved}
          onError={error => dispatch(showMessageBox(null, error))}
        />
      </div>
    )
  } else return <p>Não existem Faltas</p>
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({
  selectedPicking,
})
export default connect(mapStateToProps)(Faltas)
